import React from 'react';
import { useParams } from 'react-router-dom';

const PrivacyPage: React.FC = () => {
  const { serviceKey } = useParams<{ serviceKey: string }>();
  return (
    <main className="max-w-2xl mx-auto py-10 px-4 text-foreground">
      <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
      <p className="mb-4">At {serviceKey ? serviceKey : 'our service'}, we value your privacy and are committed to protecting your personal information.</p>
      <ul className="list-disc pl-6 space-y-2 mb-4">
        <li>We collect only the information necessary to provide and improve our services.</li>
        <li>Your data is never sold to third parties.</li>
        <li>We use industry-standard security measures to protect your information.</li>
        <li>You may request deletion of your data at any time by contacting support@{serviceKey ? serviceKey : 'ourservice'}.com.</li>
        <li>This policy may be updated periodically. Please review it regularly.</li>
      </ul>
      <p>For privacy-related questions, contact support@{serviceKey ? serviceKey : 'ourservice'}.com.</p>
    </main>
  );
};

export default PrivacyPage;
